package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import io.horion.cv.models.DescriptionState
import io.horion.cv.viewModel.CvViewModel

@Composable
fun PersonalizedDescriptionForm(
    state: DescriptionState,
    cvViewModel: CvViewModel
) {
    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        DescriptionForm(
            state = state,
            onDescriptionChange = { newDescription ->
                state.description = newDescription

                cvViewModel.updatePersonalizedSection(
                    sectionId = state.sectionId
                ) { section ->
                    section.copy(
                        description = newDescription
                    )
                }
            }
        )
    }
}

@Composable
fun PersonalizedEntriesForm(
    sectionId: String,
    cvViewModel: CvViewModel
) {
    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        EntryAccordionContent(
            sectionId = sectionId,
            cvViewModel = cvViewModel,
            onComplete = {},
            onAddFormationAndClose = {}
        )
    }
}

@Composable
fun PersonalizedCompetencesForm(
    sectionId: String,
    cvViewModel: CvViewModel
) {
    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        RubriqueCompetenceAccordionContent(
            sectionId = sectionId,
            cvViewModel = cvViewModel,
            onComplete = {},
            onAddCompetenceAndClose = {}
        )
    }
}

@Composable
fun PersonalizedListForm(
    sectionId: String,
    cvViewModel: CvViewModel
) {
    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        ListAccordionContent(
            sectionId = sectionId,
            cvViewModel = cvViewModel,
            onComplete = {},
            onAddFormationAndClose = {}
        )
    }
}